<template>
    <div class="upload-panel-wrapper col-md-5 p-0">
        <div class="close-or-min-panel">
            <div class="heading">{{$t('Profile training')}}</div>
            <div class="close-icon-wrapper">
                <cancel-icon @click.native="closePanel" class="close-icon mt-1"></cancel-icon>
            </div>
        </div>
        <div class="info-wrapper">
            <!-- <div class="normal-text-display">Steps To Train profiles</div> -->
            <div class="normal-text-display">{{$t('Steps To Train profile')}}.</div>
            <div class="normal-text-display">
                <!-- <div class="sub-header-wrapper"><b class="sub-header">Based on nature of storage content bins are classified as 4 types</b></div> -->
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">1</div></div><div class="text-for-bullet">{{$t('Upload a minimum of 25 images of a person, covering different angles')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">2</div></div><div class="text-for-bullet">{{$t('If a single person is found in the uploaded image, there is no need to tag the face')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">3</div></div><div class="text-for-bullet">{{$t('If multiple faces are found in the uploaded image, you will see')}}
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="orange" class="bi bi-person-fill-exclamation" viewBox="0 0 16 16">
                        <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                        <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"/>
                    </svg>. {{$t('When multiple faces are detected, you need to tag the face of the person you intend to train')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">4</div></div><div class="text-for-bullet">{{$t('Make sure the icon')}}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#169116" class="bi bi-person-fill-check exisited-profile-face" viewBox="0 0 16 16">
                        <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                        <path d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                    </svg>
                        {{$t('appears after tagging')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">5</div></div><div class="text-for-bullet">{{$t('Once you have tagged all the images')}} 
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#169116" class="bi bi-person-fill-check exisited-profile-face" viewBox="0 0 16 16">
                        <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                        <path d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                    </svg>
                        ,{{$t('click on the "Add to dataset" button')}}.</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">6</div></div><div class="text-for-bullet">{{$t('The system will extract faces from the images and create a dataset. Switch to the "dataset" tab to view the extracted faces. This process may take a few minutes to complete. You can monitor the status in the Jobs section')}}</div></div>
                <div class="text-with-bullets-wrapper"><div class="bullets-wrapper"><div class="bullets">7</div></div><div class="text-for-bullet">{{$t('Once you have received the extracted faces in the dataset, click on the "Train Dataset" button. The system will communicate with the AI service to train the profile. The AI engine will be trained based on the configuration')}}</div></div>
            </div>

           <div class="example-div">
                <div>
                    <b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                    </svg>{{$t('Some points to remember')}}:</b>
                    <div> 
                        <ul class="advanced-value-example-ul">
                            <li> <b>*</b> {{$t('Preferably upload images with single person')}} </li>
                            <li> <b>*</b> {{$t("Don't upload  blur images")}} </li>
                            <li> <b>*</b> {{$t('Face should be having minimum 72X72 px, i.e smaller faces in group images are not recommended')}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="note-div">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-journal-text" viewBox="0 0 16 16">
                        <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
                        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/>
                        <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>
                    </svg>
                </div>
                <div>
                    <b style="color: #85ce9f;">{{$t('Note')}} :</b>
                    <ul class="advanced-value-note-ul" style="margin-inline-start:0px">    
                       <li> 
                            <b>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="orange" class="bi bi-clock-history" viewBox="0 0 16 16">
                                    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/>
                                    <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/>
                                    <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
                                </svg>
                            </b> 
                            <div>{{$t('Face Detection in progress')}}</div>
                        </li>
                        <li> 
                            <b>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#169116" class="bi bi-person-fill-check exisited-profile-face" viewBox="0 0 16 16">
                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514ZM11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                                    <path d="M2 13c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                </svg>
                            </b> 
                            <div>{{$t('Only one Face detected OR the selected personality is tagged from multiple faces')}} </div>
                        </li>
                        <li> 
                            <b> 
                                <svg  xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="orange" class="bi bi-person-fill-exclamation" viewBox="0 0 16 16">
                                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5Zm0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"/>
                                </svg>
                            </b>   
                            <div>{{$t('Multiple faces were found, and the selected personality is not tagged')}}</div>
                        </li>
                        <li> 
                            <b> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#d75555" class="bi bi-person-fill-x" viewBox="0 0 16 16">
                                    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 8c0 1 1 1 1 1h5.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.544-3.393C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4Z"/>
                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.646-4.854.646.647.646-.647a.5.5 0 0 1 .708.708l-.647.646.647.646a.5.5 0 0 1-.708.708l-.646-.647-.646.647a.5.5 0 0 1-.708-.708l.647-.646-.647-.646a.5.5 0 0 1 .708-.708Z"/>
                                </svg>
                            </b>   
                            <div>{{$t('The size of the detected face is not sufficient to allow it to be added to the dataset OR Unsupported file format')}}</div>
                        </li>                        
                    </ul>  
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import cancelIcon from "../core/InlineCancelField.vue"
export default {
    components:{
        'cancel-icon':cancelIcon,
    },
    methods:{
        closePanel(){
            this.$emit("close");
        },
    },
}
</script>

<style scoped lang="scss">
$dull-text-color: #858585;
$active-green-color:#28a745;
$overlay-info-panel-bg-color:#1b1b1b;
$overlay-panel-border-color:#272727;
$panel-heading-font-size:24px;
$info-color:rgb(209, 210, 211);
$info-font-size:15px;
$info-sub-header-color:#e8912d;
$info-header-font-size:22px;
$tip-border-color:#23485f;
$tip-background-color:#10202a;
$tip-text-color:#8aa1ad;
$tip-icon-color:#85b5ce;
$bullet-background-color:#295318;
$close-icon-bg-on-hover:#3a3a3a;
$border-color: 1px solid #4a4a4a;
$border-color-only:#4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$input-field-height:38px;
$none-text-color:#4f4f4f;
$input-field-padding:.375rem 10px;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555;
$tags-background-color:#282d31;
$button-height:38px;
$tags-border-color:#363636;
$metadata-border-color-on-hover: #5a5a5a;
$secondary-border-color: 1px solid #2b2b2b;
$active-green-color:#28a745;
$svg-color:#666;
$learn-about-text-color-hover:#b7b327;
$active-green-icon-color: #00ff3a;
$learn-about-text-color:#9a9620;
$icon-hover:#2c3339;
$note-border-color:#1f4d27;
$note-background-color:#0e28197a;
$note-text-color:#6eab84;
$note-icon-color:#85ce9f;
$example-background-color:#1b1b1b;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;

.active{
    color:$active-blue;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.filters-bar{
    max-height: 100%;
    width: 100%;
    overflow:auto;
    display:inline-block;
    ul{
        list-style-type: none;
        padding-inline-start:2px;
        li{
            text-align: start;
            margin-inline-start: 6%;
            margin-top: 9px;
        }
    }
}
.upload-panel-wrapper{
    border-inline-start: $secondary-border-color;
    position: absolute;
    background: $primary-background;
    bottom: 1px!important;
    top: 2px !important;
    inset-inline-end: 0%;
    z-index: 9;
    max-height: 100%;
    height: 100%;
    box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -webkit-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -moz-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    .close-or-min-panel{
            height: 60px;
            width:100%;
            border-bottom: $secondary-border-color;
            background: $secondary-background-color;
            text-align: end;
            padding: 12px;
            display: flex;
            justify-content: flex-end;
        }
    .info-wrapper{
            width: 100%;
            padding: 24px;
            overflow:auto;
            display:inline-block;
            height: 90%;
            .edit-upload-info{
                width:8%;
                padding: 5px;
                    svg{
                        position: relative;
                        inset-inline-end: 6px;
                    }
            }
            }
        }



.edit-upload-info{
    position: relative;
    inset-inline-start:0px;
}

.minHeight{
    height:52px !important;
    bottom:1px !important;
    top: unset !important;
}

.upload-bars{
    margin-bottom: 12px;
}

.heading{
    text-align:start;
    width:94%;
    padding:2px;
    font-size:$panel-heading-font-size;
}

.normal-text-display{
    text-align: start;
    margin-bottom: 10px;
    color:$info-color;
    font-size:$info-font-size;
}

.sub-header{
    color: $info-sub-header-color;
    font-weight: 100;
    font-size:$info-header-font-size
}

.sub-header-wrapper{
    margin:25px 0px 5px 0px;
}

.tip-div{
    width: 100%;
    height: auto;
    display:inline-flex;
    padding: 12px;
    text-align: start;
    border: 1px solid $tip-border-color;
    background: $tip-background-color;
    border-radius: 5px;
    margin: 20px 0;
    color: $tip-text-color;
    svg{
        margin: 0px 14px 0px 0px;
        color: $tip-icon-color;
    }
}

.text-with-bullets-wrapper{
    display:inline-flex;
    margin-bottom: 10px;
    .bullets-wrapper{
        .bullets{
            height: 23px;
            width: 23px;
            border-radius: 8px;
            background: $bullet-background-color;
            margin: 0 auto;
            padding-inline-start: 7px;
            padding-top: 1px;
            margin: 3px 14px 0px 5px;
        }
    }
    .text-for-bullet{
        padding-top:4px;
    }
}

.image-wrapper{
    height: auto;
    width: 250px;
    margin: 20px auto;
}

.close-icon-wrapper{
    position: relative;
    bottom: 1px;
    .close-icon{
        height: 30px !important;
        width: 30px !important;
        color: $dull-text-color !important;
    }
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

.note-div{
    width: 100%;
    height: auto;
    display:inline-flex;
    padding: 12px;
    text-align: start;
    border: 1px solid $note-border-color;
    background: $note-background-color;
    border-radius: 5px;
    margin: 0px 0 20px 0;
    color: $note-text-color;
    svg{
        margin: 0px 14px 0px 0px;
        color: $note-icon-color;
    }
}

.advanced-value-note-ul{
    // margin-inline-start: 25px;
    margin: 12px 0px !important;
    li{
        list-style-type: none;
        font-style: italic;
        display: inline-flex;
        align-items: baseline;
        padding: 2px 0px;
        font-style:normal;
        b{
            font-size: 18px;
            margin: 0px 5px;
            svg{
                margin:0px 4px 0px 0px !important;
            }
        }
    }
}

.advanced-value-example-ul{
    margin-inline-start: 25px;
    li{
        padding: 0px 8px;
        list-style-type: none;
        font-style: italic;
        b{
            font-size: 18px;
            margin: 0px 5px;
        }
    }
}

.example-div{
    width: 100%;
    height: auto;
    display:inline-flex;
    padding: 12px;
    text-align: start;
    border: $border-color;
    background: $example-background-color;
    border-radius: 5px;
    margin: 20px 0;
    color: $options-text-color;
    b{
        color:$options-text-color;
    }
    svg{
        margin: 0px 14px 0px 0px;
        color: $options-text-color;
    }
}
</style>



